export const navbarHeight = 60
